import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { Pricing } from './Pricing.client';
import { Dialog, DialogContent, HiddenDialogTitle } from '~/components/ui/Dialog';
import { pricingStore } from '~/lib/stores/pricing/pricing';

export const PricingOverlay = memo(() => {
  const showPricingOverlay = useStore(pricingStore.showPricingOverlay);

  function onClose() {
    pricingStore.closePricingOverlay();
  }

  return (
    <Dialog
      open={showPricingOverlay}
      contentClassName="bg-bolt-ds-surfaceOne text-bolt-ds-textPrimary max-w-7xl"
      onClose={onClose}
      maxHeight="90vh"
    >
      <HiddenDialogTitle>Pricing</HiddenDialogTitle>

      <DialogContent className="max-h-90vh overflow-y-auto text-bolt-ds-textPrimary px-0">
        <Pricing />
      </DialogContent>
    </Dialog>
  );
});
